<div class="zoom-controller-container" (click)="$event.stopPropagation()">
  <div (click)="updateValue(zoomLevel - zoomStep)"
       [dsTooltip]="'text_zoomOut' | dbText"
       dsTooltipSize="m"
       dsTooltipColor="black"
       dsTooltipPosition="top"
       dsTooltipFont="semibold"
       class="controller">
    <span class="db-icon db-icon-minus"></span>
  </div>
  <div class="zoom-level"
       [dsTooltip]="'text_zoom' | dbText"
       dsTooltipSize="m"
       dsTooltipColor="black"
       dsTooltipPosition="top"
       dsTooltipFont="semibold"
       (click)="tooltipOpened = !tooltipOpened">
    {{zoomLevel}}%
  </div>
  <div (click)="updateValue(zoomLevel + zoomStep)"
       [dsTooltip]="'text_zoomIn' | dbText"
       dsTooltipSize="m"
       dsTooltipColor="black"
       dsTooltipPosition="top"
       dsTooltipFont="semibold"
       class="controller">
    <span class="db-icon db-icon-plus"></span>
  </div>
  <db-zoom-tooltip *ngIf="tooltipOpened"
                   (close)="tooltipOpened = !tooltipOpened"
                   (zoomToFit)="triggersService.fitToScreen.next()"
                   (zoomByStep)="updateValue(zoomLevel + (zoomStep * $event))"
                   (changeZoom)="updateValue($event)">
  </db-zoom-tooltip>
</div>
